import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import { RouteNames } from "./RouteNames";
import { registerGuard } from "./Guard";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "HOME",
    component: HomeView,
  },

  {
    path: "/Erlaubniskarten",
    name: RouteNames.ERLAUBNISKARTEN,
    component: () => import("../views/ErlaubniskartenView.vue"),
    meta: {
      requiresAuth: true,
      headline: "Erlaubniskarten",
    },
  },
  {
    path: "/Fahrbewilligungen",
    name: RouteNames.FAHRBEWILLIGUNGEN,
    component: () => import("../views/FahrbewilligungenView.vue"),
    meta: {
      requiresAuth: true,
      headline: "Fahrbewilligungen",
    },
  },

  {
    // Small workaround for MSAL: The redirect back looks like "#/code=0.AR8..."
    // VueRouter does not like that so to prevent useless console errors, we just make it a valid route to home.
    path: "/code=:afterCode(.*)",
    name: "OAuthCodeReturn",
    component: HomeView,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

registerGuard(router);

export default router;
